import { Input } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';

@Component({
    selector: 'loyaltic-upload-animation-pop-up',
    templateUrl: './upload-animation-pop-up.component.html',
    styleUrls: ['./upload-animation-pop-up.component.scss'],
    standalone: false
})
export class UploadAnimationPopUpComponent implements OnInit {

  @ViewChild('uploadAnimation', { static: false }) confirmReceiptUploadRef: any;
  @Input() receipt : any;

  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  constructor(private modalService: BsModalService,
    private dataService: DataServiceService) { }

  ngOnInit() {
    this.dataService.isModalOpen.subscribe((response:any) => {
      response?'':this.modalRef.hide()
    })
  }

  ngAfterViewInit() {
    this.dataService.isModalOpen.emit(true)
    this.modalRef = this.modalService.show(this.confirmReceiptUploadRef, this.popupConfig);
  }
}
